<template>
  <v-dialog v-model="dialog" persistent max-width="500px" @keydown.esc="close()">
    <v-card>
      <v-card-title> </v-card-title>

      <v-card-text>
        <label class="file-select">
          <div class="select-button">
            <span v-if="file">File da importare : {{ file.name }}</span>
            <span v-else>Seleziona File ...</span>
          </div>
          <input type="file" @change="handleFileChange" />
        </label>
        <div>
          <v-alert :value="true" type="info" outlined>
            NOTA : <br />
            L'importazione del file non può essere annullata. <br />
            L'importazione del file andrà a sostituire le giacenze attuali.
          </v-alert>
          <v-alert
            :value="!!alertElaborazione"
            type="success"
            transition="scale-transition"
          >
            {{ alertElaborazione }}
          </v-alert>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-1"
          :disabled="loading"
          text
          @click.native="close()"
          >Annulla</v-btn
        >

        <v-btn
          :loading="loading"
          :disabled="loading"
          text
          color="primary"
          class="white--text"
          @click.native="conferma"
        >
          Importa
          <v-icon right dark>cloud_upload</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { upload_fileQtaArticoliFornitori } from "@/api/api.fornitori.js";

export default {
  props: {
    dialog: { type: Boolean, default: false },
  },

  data: () => ({
    file: "",
    loading: false,
    alertElaborazione: "",
  }),

  methods: {
    conferma() {
      // Controllo presenza file
      if (this.file.length == 0) return;

      this.loading = true;

      let formData = new FormData();
      formData.append("file", this.file);

      upload_fileQtaArticoliFornitori(formData)
        .then((res) => {
          this.loading = false;
          this.file = "";

          this.alertElaborazione =
            "Elaborazione completata : " + res.data + " record";
        })
        .catch((err) => {
          this.loading = false;

          console.log(err.response.data.Message);
        });
    },

    close() {
      // Pulisco eventuali file non importati
      this.file = "";
      this.alertElaborazione = "";

      this.$store.commit("app/SET_DIALOG", "");
    },

    handleFileChange(e) {
      // Whenever the file changes, emit the 'input' event with the file data.
      this.file = e.target.files[0];
    },
  },
};
</script>


<style scoped>
.file-select > .select-button {
  padding: 1rem;

  color: white;
  background-color: #2196f3;

  border-radius: 0.3rem;

  text-align: center;
  font-weight: bold;
  cursor: pointer;
}

/* Don't forget to hide the original file input! */
.file-select > input[type="file"] {
  display: none;
}
</style>
